import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const WhySellHeader = () => {
  const location = useLocation();
  const isPlayground = location.pathname === '/copy';
  const { t } = useLanguage();
  
  const openContactEmail = () => {
    console.log("Opening email in WhySellHeader");
    const subject = encodeURIComponent("Quiero saber más sobre Noa Partners");
    const body = encodeURIComponent("Quiero conocer más sobre cómo mi empresa podría beneficiarse al asociarse con Noa.");
    window.location.href = `mailto:info@noapartners.com?subject=${subject}&body=${body}`;
  };
  
  return (
    <section id="partner-with-noa" className="relative py-56 bg-[#2F4550] dark:bg-[#2F4550] text-white overflow-hidden min-h-screen flex items-center">
      {/* Background patterns - only shown on main version, not playground */}
      {!isPlayground && (
        <>
          <div className="absolute inset-0 bg-dot-pattern opacity-10"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-white/10"></div>
        </>
      )}
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="uppercase text-xs sm:text-sm font-bold tracking-wider text-noa-antiflash-white/80 mb-6 sm:mb-8">
            {t('why_partner_with_noa')}
          </div>
          
          {isPlayground ? (
            <h1 className="font-space-grotesk text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 sm:mb-8 leading-tight text-noa-antiflash-white">
              Powering Latin American <br />
              software companies<span className="text-blue-600">.</span>
            </h1>
          ) : (
            <h1 className="font-space-grotesk text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 sm:mb-8 leading-tight text-noa-antiflash-white">
              {t('your_legacy')} <br />
              <span>{t('our_commitment')}</span><span className="text-blue-600">.</span>
            </h1>
          )}
          
          {isPlayground ? (
            <p className="text-noa-antiflash-white/80 text-base sm:text-xl max-w-2xl leading-relaxed text-center mx-auto mb-16">
              See how we can help your B2B software business thrive in the Latin American market.
            </p>
          ) : (
            <p className="text-noa-antiflash-white/80 text-base sm:text-xl max-w-2xl leading-relaxed text-center mx-auto mb-16">
              {t('we_understand')}
            </p>
          )}

          <div className="mt-12 sm:mt-16 flex justify-center animate-fade-in opacity-0" style={{ animationDelay: "0.5s", animationFillMode: "forwards" }}>
            <p className="text-noa-antiflash-white/70 text-lg">{t('scroll_to_learn_more')}</p>
          </div>
          <div className="flex justify-center mt-4 animate-bounce">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto">
              <path d="M12 5v14"></path>
              <path d="m19 12-7 7-7-7"></path>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySellHeader;
